import React from "react";
import { Field } from "formik";
import Select, { SelectMultipleChip } from "components/select";
import { formikPropTypes } from "components/common";

const ValidatedSelect = ({ field: { name, value, onChange, onBlur }, SelectComponent, ...props }) => {
  return <SelectComponent name={name} value={value} onChange={onChange} onBlur={onBlur} {...props} />;
};

ValidatedSelect.propTypes = {
  ...formikPropTypes,
  ...Select.propTypes,
};

const FormSelect = ({ component, multiple = false, name, onChange, value, onBlur, ...props }) => {
  const defaultComponent = multiple ? SelectMultipleChip : Select;
  const SelectComponent = component ? component : defaultComponent;

  return (
    <Field
      component={ValidatedSelect}
      field={{
        name,
        onChange: onChange(name),
        value,
        onBlur,
      }}
      SelectComponent={SelectComponent}
      {...props}
    />
  );
};

FormSelect.propTypes = {
  ...Select.propTypes,
};

export default FormSelect;
